import { render } from "./Notes13.vue?vue&type=template&id=a628b9e6&scoped=true"
import script from "./Notes13.vue?vue&type=script&lang=js"
export * from "./Notes13.vue?vue&type=script&lang=js"

import "./Notes13.vue?vue&type=style&index=0&id=a628b9e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a628b9e6"]])

export default __exports__